(function () {
  const COPY_RESET_DELAY = 1800;

  function copyCode(button) {
    const code = button.dataset.llCopyCode;
    const label = button.querySelector('[data-ll-copy-label]');
    if (!code || !label) return;

    const markCopied = () => {
      label.textContent = 'Copiat';
      window.setTimeout(() => {
        if (label.isConnected) label.textContent = 'Copiază';
      }, COPY_RESET_DELAY);
    };

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(markCopied).catch(() => {});
      return;
    }

    const input = document.createElement('textarea');
    input.value = code;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    try {
      document.execCommand('copy');
      markCopied();
    } catch (error) {
      // The promotion remains readable if clipboard access is unavailable.
    }
    input.remove();
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ll-copy-code]');
    if (button) copyCode(button);
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('.ll-cart-quantity .quantity-input');
    if (!input) return;
    const root = input.closest('cart-items, cart-drawer-items');
    if (root) {
      root.setAttribute('aria-busy', 'true');
      window.setTimeout(() => {
        if (root.isConnected) root.removeAttribute('aria-busy');
      }, 6000);
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    if (!window.theme || !window.theme.pubsub || !window.theme.pubsub.PUB_SUB_EVENTS) return;
    window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, () => {
      document.querySelectorAll('cart-items[aria-busy="true"], cart-drawer-items[aria-busy="true"]').forEach((root) => {
        root.removeAttribute('aria-busy');
      });
    });
  });
})();
